var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"iconOuter"},[_c('div',{staticClass:"iconPosition"},[_c('div',{staticClass:"iconFormPlus"},[_c('div',{staticClass:"formPlus"},[_c('van-icon',{attrs:{"name":"plus"},on:{"click":_vm.fillOutForm}})],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }